interface IKeepitalConstant {
  ID: string;
}

const KEEPITAL: IKeepitalConstant = {
  ID: 'cR5zCXNSafmJB4ZPB',
};

export default KEEPITAL;
